<template>
    <ak-form-decorator
        :id="id"
        :title="title"
        :helpText="helpText"
        :error="error"
        :hasError="hasError"
        :required="required"
        :value="value"
        :locales="locales"
    >
        <div
            v-html="value"
            :style="  ! isHtml ? 'white-space: pre-line;' : '' "
        />
    </ak-form-decorator>
</template>

<script>
import FormElementMixin from "../../../../vendor/multimedium/spine/resources/spine-appkit-vue/src/components/form/mixins/FormElementMixin";

export default {
    name: 'ak-html-read-only',
    props: {
        isHtml: {
            type: Boolean,
            default: false
        }
    },
    mixins: [FormElementMixin],
}
</script>

